import React from 'react';

const CaseNotes = ({ notes, newNote, setNewNote, addNote, resolveActor }) => {
    const formatActor = (note) => {
        if (!resolveActor) return null;
        const actor = resolveActor(note?.author_id || note?.author_email);
        if (!actor) return null;
        const displayName = actor.name || actor.email || actor.id;
        if (!displayName) return null;
        if (actor.id && displayName !== actor.id) return `${displayName} (${actor.id})`;
        return displayName;
    };

    return (
        <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-lg overflow-hidden">
            <div className="bg-gray-900/50 p-4 border-b border-gray-700 flex justify-between items-center">
                <h4 className="text-lg font-bold text-purple-400 uppercase tracking-wider flex items-center gap-2">
                    📝 LOGS & NOTES
                </h4>
            </div>
            <div className="p-4">
                <div className="mb-6 bg-gray-900/50 p-4 rounded border border-gray-700">
                    <textarea
                        className="w-full bg-transparent border-none text-white placeholder-gray-600 text-sm focus:ring-0 font-mono resize-none"
                        placeholder="ENTER NEW LOG ENTRY..."
                        rows="3"
                        value={newNote}
                        onChange={(e) => setNewNote(e.target.value)}
                    />
                    <div className="flex justify-end mt-2 pt-2 border-t border-gray-700">
                        <button
                            onClick={addNote}
                            className="px-4 py-2 rounded text-xs font-bold bg-blue-600 text-white hover:bg-blue-700 uppercase tracking-wider border border-blue-500"
                        >
                            Add Entry
                        </button>
                    </div>
                </div>

                <ul className="space-y-4">
                    {notes.map(n => (
                        <li key={n.id} className="relative pl-6 border-l-2 border-gray-700 pb-4 last:pb-0 last:border-0">
                            <div className="absolute -left-[5px] top-0 w-2 h-2 rounded-full bg-gray-600"></div>
                            <div className="bg-gray-700/30 p-3 rounded border border-gray-700/50">
                                <div className="flex flex-wrap items-baseline gap-2 mb-1">
                                    <div className="text-xs text-gray-500 font-mono uppercase tracking-wider">
                                        {new Date(n.created_at).toLocaleString()}
                                    </div>
                                    {formatActor(n) && (
                                        <div className="text-[10px] text-gray-400 font-mono uppercase bg-gray-900/60 px-2 py-0.5 rounded border border-gray-700/70">
                                            BY: {formatActor(n)}
                                        </div>
                                    )}
                                </div>
                                <div className="text-sm text-gray-300 font-mono whitespace-pre-wrap leading-relaxed">
                                    {n.content}
                                </div>
                            </div>
                        </li>
                    ))}
                    {notes.length === 0 && <li className="text-center py-8 text-gray-500 font-mono uppercase">No logs recorded</li>}
                </ul>
            </div>
        </div>
    );
};

export default CaseNotes;
